import { render } from "./SelectInputFunction.vue?vue&type=template&id=b3c2318e"
import script from "./SelectInputFunction.vue?vue&type=script&lang=js"
export * from "./SelectInputFunction.vue?vue&type=script&lang=js"

import exportComponent from "/media/dolar/office/office_project/oneGov-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__